import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../chunks/tslib.es6.js";
import r from "../core/Accessor.js";
import e from "../core/Error.js";
import o from "../core/Logger.js";
import { isSome as s, isNone as a, get as p } from "../core/maybe.js";
import { isAbsolute as l, makeRelative as i } from "../core/urlUtils.js";
import { property as c } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import { cast as m } from "../core/accessorSupport/decorators/cast.js";
import { subclass as u } from "../core/accessorSupport/decorators/subclass.js";
var h = o.getLogger("esri.portal.PortalItemResource");

var n = /*#__PURE__*/function (_r) {
  _inherits(n, _r);

  var _super = _createSuper(n);

  function n(t) {
    var _this;

    _classCallCheck(this, n);

    _this = _super.call(this, t), _this.portalItem = null;
    return _this;
  }

  _createClass(n, [{
    key: "normalizeCtorArgs",
    value: function normalizeCtorArgs(t) {
      return t && t.portalItem && t.path ? _objectSpread(_objectSpread({}, t), {}, {
        path: this.normalizePath(t.path, t.portalItem)
      }) : t;
    }
  }, {
    key: "path",
    set: function set(t) {
      s(t) && l(t) ? h.error("portalitemresource:invalid-path", "A portal item resource path must be relative") : this._set("path", t);
    }
  }, {
    key: "_castPath",
    value: function _castPath(t) {
      return this.normalizePath(t, this.portalItem);
    }
  }, {
    key: "url",
    get: function get() {
      return this.portalItem && this.path ? "".concat(this.portalItem.itemUrl, "/resources/").concat(this.path) : null;
    }
  }, {
    key: "itemRelativeUrl",
    get: function get() {
      return this.portalItem && this.path ? "./resources/".concat(this.path) : null;
    }
  }, {
    key: "fetch",
    value: function fetch() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "json";
      var r = arguments.length > 1 ? arguments[1] : undefined;
      var o = this.url;
      if (a(o)) throw new e("portal-item-resource:fetch", "Portal item resource does not refer to a valid item or path");
      return this.portalItem.portal._request(o, {
        responseType: t,
        query: {
          token: this.portalItem.apiKey
        },
        signal: p(r, "signal")
      });
    }
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t, r) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return import("./support/resourceUtils.js");

              case 2:
                return _context.abrupt("return", _context.sent.addOrUpdateResource(this, "update", t, r));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function update(_x, _x2) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "hasPath",
    value: function hasPath() {
      return s(this.path);
    }
  }, {
    key: "normalizePath",
    value: function normalizePath(t, r) {
      return a(t) ? t : (t = t.replace(/^\/+/, ""), s(r) && l(t) && (t = i(t, r.itemUrl)), t.replace(/^\/+/, "").replace(/^(\.\/)?resources\//, ""));
    }
  }]);

  return n;
}(r);

t([c()], n.prototype, "portalItem", void 0), t([c({
  type: String,
  value: null
})], n.prototype, "path", null), t([m("path")], n.prototype, "_castPath", null), t([c({
  type: String,
  readOnly: !0
})], n.prototype, "url", null), t([c({
  type: String,
  readOnly: !0
})], n.prototype, "itemRelativeUrl", null), n = t([u("esri.portal.PortalItemResource")], n);
var y = n;
export { y as default };